import { dummyData, randomCaption } from '@modules/VanOord.Styleguide/Frontend/config/dummyData'
import { ComponentCTABlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/ctaBlock.sg'
import { ComponentDownloadBlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/downloadBlock.sg'
import { ComponentExpandableBlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/expandableBlock.sg'
import { ComponentGridBlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/gridBlock.sg'
import { ComponentMediaBlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/mediaBlock.sg'
import { ComponentOfficeBlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/officeBlock.sg'
import { ComponentQuoteBlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/quoteBlock.sg'
import { ComponentTextBlock } from '@modules/VanOord.Styleguide/Frontend/content/components/blocks/textBlock.sg'
import { ComponentSiteheader } from '@modules/VanOord.Styleguide/Frontend/content/components/siteheader.sg'
import * as React from 'react'
import { Widget, any, fromJSX } from 'widgets-for-react'
import {
  filtersBlock,
  pressContactBlock,
  resultsBlock,
  resultsDownloadBlock,
  searchBlock,
  searchDropdownBlock,
  updatesBlock,
  updatesOverview
} from '../fake_data/buildingblocks'
import { footer } from '../fake_data/footer'
import { pagination } from '../fake_data/objects'
import { genericHeader, resultsHeader } from '../fake_data/pageheader'
import { styleguideChapter, styleguideExample, styleguidePart, styleguideSection } from '../helpers.mod'

export const styleguideCompositions: Widget<never> =
    styleguideChapter({ type: 'compositions', slug: 'compositions', title: 'Design Compositions', intro: '' })(
      any([
        styleguideSection({ type: 'compositions', slug: 'compositions-page', title: 'Page', intro: '' })(
          any([
            styleguidePart({ title: '', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(() => (
                    <>
                      <ComponentSiteheader />
                      {genericHeader()}
                      <ComponentOfficeBlock />
                      <ComponentQuoteBlock />
                      {pressContactBlock(false)}
                      <ComponentQuoteBlock showImage />
                      {pressContactBlock(true)}
                      {updatesBlock()}
                      <ComponentCTABlock bgColor="green" />
                      <ComponentExpandableBlock />
                      <ComponentTextBlock />
                      <ComponentGridBlock variant="image" bgColour="grey" />
                      <ComponentMediaBlock
                        mediaType="image"
                        items={[
                          {
                            mediaType: 'image',
                            image: dummyData.image,
                            caption: randomCaption(),
                            displayOption: 'full-width'
                          }
                        ]}
                      />
                      <ComponentDownloadBlock />
                      {footer()}
                    </>
                  )
                )
              )
            )
          ])
        ),
        styleguideSection({
          type: 'compositions',
          slug: 'compositions-updates',
          title: 'Updates overview page',
          intro: ''
        })(
          any([
            styleguidePart({ title: '', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(() => (
                    <>
                      <ComponentSiteheader />
                      {genericHeader()}
                      {filtersBlock()}
                      {updatesOverview()}
                      {pagination()}
                      {searchBlock()}
                      {footer()}
                    </>
                  )
                )
              )
            )
          ])
        ),
        styleguideSection({
          type: 'compositions',
          slug: 'compositions-vacancies',
          title: 'vacancies overview page',
          intro: ''
        })(
          any([
            styleguidePart({ title: '', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(() => (
                    <>
                      <ComponentSiteheader />
                      {resultsHeader()}
                      {searchDropdownBlock()}
                      {resultsBlock()}
                      {footer()}
                    </>
                  )
                )
              )
            )
          ])
        ),
        styleguideSection({ type: 'compositions', slug: 'compositions-search', title: 'Search page', intro: '' })(
          any([
            styleguidePart({ title: '', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                  fromJSX(() => (
                    <>
                      <ComponentSiteheader />
                      {resultsHeader()}
                      {searchBlock()}
                      {resultsBlock()}
                      {resultsDownloadBlock()}
                      {footer()}
                    </>
                  )
                )
              )
            )
          ])
        )
      ])
    ).never()
